// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

interface FetchType {
    coa_code: string
    coa_name: string
    group_coa_code: string
    coa_id: number
}

export function useLinkAccountByCode(code: string): {
    data: FetchType | null
    isLoading: boolean
} {
    // Hooks
    const api = useApi()
    const [data, setData] = useState<FetchType | null>(null)
    const [isLoading, setLoading] = useState<boolean>(true)

    const fetchUrl = () => {
        return api.get("/linkedaccount/bycode", {
            params: { linked_account_code: code }
        })
    }

    const fetchData = () => {
        fetchUrl().then((res: SuccessFetch<{
            payload: FetchType[]
        }>) => {
            setData(res.data.payload[0])
        }).catch(() => {
            setData(null)
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        fetchData()

        return () => {
            setData(null)
            setLoading(true)
        }

        // eslint-disable-next-line
    }, [])

    return { data, isLoading }

}